<template>
<div class="dashboard">
      <submissionsList/>
</div>
</template>

<script>
import submissionsList from '@/components/submissionsList'

// dispatch loadUsers & loadSubmissions

export default {
    name: 'Submissions',
    components: {
        submissionsList
    }
}
</script>

<style>
/*
.dashboard:before{
    content: "";
    position: absolute;
    left:0;
    top:0;
    width:100%;
    height: 100%;
    opacity:0.7;
    background-color: #000000;
    z-index:0;
}*/
.dashboard{
  
  height: 100%;
  background-image: url(../assets/CarWall16.jpg);
  background-size: cover;
   background-color: rgba(30,0,0,0.6);
  background-blend-mode: darken;
}
#subsmissions-data-table{
  opacity: 0.95!important;
}
</style>
